export const UPDATE_SITE_CONFIG = 'UPDATE_SITE_CONFIG';
